import { render } from "./TalentIntelligenceComponent.vue?vue&type=template&id=ab03297e&scoped=true"
import script from "./TalentIntelligenceComponent.vue?vue&type=script&lang=js"
export * from "./TalentIntelligenceComponent.vue?vue&type=script&lang=js"

import "./TalentIntelligenceComponent.vue?vue&type=style&index=0&id=ab03297e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab03297e"]])

export default __exports__